// @flow
import React, { type Node } from 'react';
import stylesheet from './Radio.scss';

type Props = {
  id: string,
  name: string,
  children: Node,
  checked?: boolean,
  onChange?: (e: SyntheticEvent<HTMLInputElement>) => void,
};

const Radio = ({
  id,
  name,
  children,
  checked = false,
  onChange = () => {},
  ...props
}: Props) => {
  return (
    <span>
      <input
        className={stylesheet['radio__input']}
        defaultChecked={checked}
        type="radio"
        id={id}
        name={name}
        onChange={onChange}
        {...props}
      />
      <label className={stylesheet['radio__label']} htmlFor={id}>
        <span className={stylesheet['radio__dot-container']}>
          <span className={stylesheet['radio__dot']} />
        </span>
        <span className={stylesheet['radio__text']}>{children}</span>
      </label>
    </span>
  );
};

export default Radio;
